import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState, useContext, useCallback } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import EditIcon from '@mui/icons-material/Edit';
import Settings from '@mui/icons-material/Settings';
import { useNavigate } from "react-router-dom";
import { getEventModuleAPI, resetGetEventModule } from "../../store/event-module/geteventlist";
import DataGridComponent from "../../components/DataGridComponent";
import { EditEventModuleApi } from "../../store/event-module/editevent";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import DeleteEventModule from "./DeleteEventModule";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import apiRoutes from "../../store/apiConfigs";
import { ThemeContext } from '../../context/ThemeContext';
import { ArrowRight as ArrowRightIcon, Check as CheckIcon } from "@mui/icons-material";
import PermissionGate from "../../components/PermissionGate";

export default function EventModule() {
  const [isDownload, setIsDownload] = useState(false)
  const settingList = useSelector((state) => state?.getDetailsEventModule);
  const { result, loading } = settingList;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});
  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const handleNavigation = async (id, eventModuleData) => {
    navigate(`/edit-event-module/${id}`, { state: { eventModuleData } });
  };
  const handleSettingNavigation = async (id, eventModuleData) => {
    navigate(`setting/${id}`, { state: { eventModuleData } });
  };

  const callEventList = useCallback(() => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      search: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(getEventModuleAPI(query));
  }, [dispatch, paginationModel, queryOptions])

  const handlePublishUnpublishChannel = async (record) => {
    dispatch(EditEventModuleApi({
      ...record.row,
      event_id: record.row.id,
      is_published: !record.row.is_published
    })).then((action) => {
      if (!action.type.includes("rejected")) {
        callEventList()
      }
    }).catch(err => console.log(err))
  }

  const columns = [
    {
      field: "id",
      headerName: "Event Id",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "title",
      headerName: "Title",
      sortable: false,
      width: 400,
    },
    {
      field: "banner",
      headerName: "Banner Image",
      width: 250,
      filterable: false,
      sortable: false,
      renderCell: (params) => (<img width={200} height={100} src={params.row.banner} alt='banner image' />)
    },
    {
      field: "start_date",
      headerName: "From Date",
      sortable: false,
      filterable: false,
      width: 200,
    },
    {
      field: "end_date",
      headerName: "To Date",
      sortable: false,
      filterable: false,
      width: 200,
    },
    {
      field: "update_setting",
      headerName: "Update",
      width: 400,
      filterable: false,
      sortable: false,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="event" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => handleNavigation(row.id, row.row)}
            >
              Edit
            </Button>
          </PermissionGate>
          <Button
            color="info"
            endIcon={<Settings />}
            label="Available" variant="contained"
            sx={{ margin: "0px 10px" }}
            onClick={() => handleSettingNavigation(row.id, row.row)}
          >
            settings
          </Button>
          <Button
            color="info"
            sx={{ margin: "0px 10px" }}
            label="Available" variant="outlined"
            onClick={() => navigate(`/event-content/${row.row.id}`)}
          >
            {"Content"}
          </Button>
        </>
      ),
    },
    // {
    //   field: "delete_event_module",
    //   headerName: "Delete Event",
    //   filterable: false,
    //   sortable: false,
    //   width: 150,
    //   disableExport: true,
    //   renderCell: (row) => (
    //     <>
    //       <Button
    //         endIcon={<DeleteOutlineIcon />}
    //         color="error"
    //         variant="outlined"
    //         style={{ marginLeft: "5px" }}
    //         onClick={() => {
    //           setNotSelectedProductModel(true);
    //           setDeleteId(row.id);
    //         }}
    //       >
    //         Delete
    //       </Button>
    //     </>
    //   ),
    // },
    {
      field: "actions",
      headerName: "Actions",
      filterable: false,
      sortable: false,
      width: 300,
      disableExport: true,
      renderCell: (data) => (
        <Box display={"flex"} justifyItems={"center"} alignItems={"center"} justifyContent={"space-around"} width={"100%"}>
          <PermissionGate module="event" action="delete">
            <Button
              endIcon={<DeleteOutlineIcon />}
              color="error"
              variant="outlined"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                setNotSelectedProductModel(true);
                setDeleteId(data.id);
              }}
            >
              Delete
            </Button>
          </PermissionGate>
          <PermissionGate module="event" action={data?.row?.is_published ? "unpublish" : "publish"}>
            <Button color="success" variant="contained"
              endIcon={data?.row?.is_published ? <CheckIcon /> : <ArrowRightIcon />}
              onClick={() => handlePublishUnpublishChannel(data)}
            >
              {data?.row?.is_published ? "UnPublish" : "Publish"}
            </Button>
          </PermissionGate>
        </Box>
      ),
    },
  ];



  useEffect(() => {
    callEventList()
  }, [dispatch, paginationModel, queryOptions, callEventList]);

  const addToCartHandler = async () => {
    navigate("/add-event-module");
  };
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Event management</Typography>
        </Stack>
        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <PermissionGate module="event" action="create">
              <Button
                onClick={addToCartHandler}
                variant="contained"
              >
                Add event
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>
        <Paper elevation={0}>
          <DataGridComponent
            sx={{
              height: 500
            }}
            getRowId={(row) => row.id}
            rows={result}
            rowCount={settingList.total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            onFilterModelChange={onFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            columns={columns}
            loading={loading}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
              (CustomGridToolbar({
                ...props, moduleType: "eventListing", queryOptions: queryOptions, paginationModel: paginationModel, isDownload, setIsDownload, permissionModule: "event", apiUrl: apiRoutes.publicapiAction(`admin/events`, 1),
              })),
            }}
            slotProps={{
              loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'linear-progress',
              },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>

      </Body>
      <DeleteEventModule
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        setSelectedRow={setSelectedRow}
        id={deleteId}
      />
    </>
  );
}
